import dynamic from 'next/dynamic';
import React from 'react';
import { GlobalProvider } from '@/context/Global';

// Types
interface IProps {
	children: React.ReactNode;
}
const QueryProvider = dynamic(
	async () => await import('../QueryProvider').then(mod => mod.QueryProvider),
);
const CCPACookiesProvider = dynamic(
	async () =>
		await import('@/features/CCPACookies').then(mod => mod.CCPACookiesProvider),
);
const CookiesProvider = dynamic(
	async () =>
		await import('@/features/Cookies').then(mod => mod.CookiesProvider),
);
const GpcToast = dynamic(
	async () => await import('@/features/gpc').then(mod => mod.GpcToast),
	{ ssr: false },
);

export const Providers: React.FC<IProps> = ({ children }) => {
	return (
		<QueryProvider>
			<GlobalProvider>
				<CookiesProvider>
					<CCPACookiesProvider>
						<>{children}</>
						<GpcToast />
					</CCPACookiesProvider>
				</CookiesProvider>
			</GlobalProvider>
		</QueryProvider>
	);
};
